export interface DispenseLog {
  id: number;
  transactionId: number;
  transactionNumber: number;
  orderDeviceId: number;
  orderDeviceName: string;
  workstationId: number;
  isVoid: boolean;
  isVoidAcknowledged: boolean;
  dateVoidAcknowledged?: string;
  dateCreated: string;
  state: DispenseState;
  dateStateChanged?: string;
  datePreparing?: string;
  dateReadyToServe?: string;
  dateServed?: string;
  printSuccess?: boolean;
  datePrinted?: string;
  printError?: string;
  printerId?: number;
  printerName?: string;
  tableNumber?: string;
  items: DispenseLogItem[];
}

export interface DispenseLogItem {
  id: number;
  transactionLineItemId: number;
  description: string;
  quantity: number;
  unitOfSaleId?: number;
  unitOfSaleName?: string;
  isVoid: boolean;
  dateVoided?: string;
  operatorId?: number;
  operatorName?: string;
  childItems: DispenseLogChildItem[];
}

export interface DispenseLogChildItem {
  transactionLineItemId: number;
  description: string;
  quantity: number;
}

export enum DispenseState {
  Pending = 0,
  Preparing = 1,
  ReadyToServe = 2,
  Served = 3,
}

export interface UpdateDispenseStateRequest {
  state: DispenseState;
}
